import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { 
  Header, 
  Footer, 
  HeroSection, 
  ValuePropsSection, 
  PlatformSection, 
  CTASection,
  ValuationSection,
  TestimonialsSection,
  ProcessSection,
  TeamSection,
  FAQSection,
  SuccessStoriesSection,
  ScrollToTop,
  IndustriesLanding,
  DentalPracticeAdvisor,
  SaaSAdvisor,
  ManufacturingPrecisionMachining,
  HVACHomeServicesAdvisor,
  CommercialCleaningAdvisor,
  CrossBorderAdvisor
} from './components';
import AboutMaster from './components/About/AboutMaster';
import BusinessValuation from './components/Services/BusinessValuation';
import BuyerSourcing from './components/Services/BuyerSourcing';
import PrivacyPolicy from './components/general/PrivacyPolicy';
import { appConfig } from './config/appConfig';

// Home Page Component
function HomePage() {
  return (
    <>
      <HeroSection />
      <ValuePropsSection />
      <PlatformSection />
      <TestimonialsSection />
      <CTASection />
    </>
  );
}

// About Page Component
function AboutPage() {
  return <AboutMaster />;
}

// Valuation Page Component
function ValuationPage() {
  return <ValuationSection />;
}

function App() {
  return (
    <div className="min-h-screen bg-white">
      <ScrollToTop />
      <Header />
      
      <main className="pt-24">
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* Legacy aliases and redirects */}
          <Route path="/buyer-sourcing" element={<Navigate to="/services/buyer-sourcing" replace />} />
          <Route
            path="/team"
            element={<Navigate to={appConfig.features.teamPage ? '/about/team' : '/about'} replace />}
          />
          <Route path="/success-stories" element={<Navigate to="/about/success-stories" replace />} />
          <Route path="/about" element={<AboutPage />} />
          <Route
            path="/about/team"
            element={appConfig.features.teamPage ? <TeamSection /> : <Navigate to="/about" replace />}
          />
          <Route path="/about/faq" element={<FAQSection />} />
          <Route path="/about/success-stories" element={<SuccessStoriesSection />} />
          <Route path="/process" element={<ProcessSection />} />
          <Route path="/about/process" element={<ProcessSection />} />
          <Route path="/valuation" element={<ValuationPage />} />
          <Route path="/services/business-valuation" element={<BusinessValuation />} />
          <Route path="/services/buyer-sourcing" element={<BuyerSourcing />} />
          <Route path="/industries" element={<IndustriesLanding />} />
          <Route path="/dentalpractice-mna-advisor" element={<DentalPracticeAdvisor />} />
          <Route path="/saas-mna-advisor" element={<SaaSAdvisor />} />
          <Route path="/manufacturing-precision-machining-mna" element={<ManufacturingPrecisionMachining />} />
          <Route path="/hvac-home-services-mna-advisor" element={<HVACHomeServicesAdvisor />} />
          <Route path="/commercial-cleaning-mna-advisor" element={<CommercialCleaningAdvisor />} />
          <Route path="/cross-border-mna-us-europe" element={<CrossBorderAdvisor />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default App;
